import { render, staticRenderFns } from "./changeLocale.vue?vue&type=template&id=2c1eaed4&scoped=true"
import script from "./changeLocale.vue?vue&type=script&lang=js"
export * from "./changeLocale.vue?vue&type=script&lang=js"
import style0 from "./changeLocale.vue?vue&type=style&index=0&id=2c1eaed4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c1eaed4",
  null
  
)

export default component.exports